import 'hiq/dist/hiq.min.css'
import 'normalize.css'
import 'focus-visible'

import { ST } from './src/utils/consoleArt'

console.log(ST, 'color: #da2828')
